import { useContext } from 'react';

import { ModelContext } from '../components/model-context/ModelContext';

export const useModelContext = () => {
  const context = useContext(ModelContext);
  if (context === undefined) {
    throw new Error('useModelContext must be used within a ModelProvider');
  }
  return context;
};
